//TODO THIS IS FOR TESTING PURPOSES ONLY AND WILL BE REMOVED AFTER THE QA PROCESS IS COMPLETED

import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenericChartComponent } from '../../shared/echarts';
import { MockChartApiService } from '../../shared/echarts/services/mock-chart-api.service';
import { 
  BoxplotChartConfig,
  MixedChartConfig,
  TimeSeriesChartConfig,
  LineChartConfig,
  BarChartConfig,
  PieChartConfig,
} from '../../shared/echarts';

/**
 * Charts Demo / Playground Page
 * Showcases all available chart types with real-world examples
 */
@Component({
  selector: 'app-charts-demo',
  standalone: true,
  imports: [CommonModule, GenericChartComponent],
  templateUrl: './charts-demo.component.html',
})
export class ChartsDemoComponent implements OnInit {
  // Chart configurations
  riskDistributionConfig?: BoxplotChartConfig;
  performanceDistributionConfig?: MixedChartConfig;
  riskTrendsConfig?: TimeSeriesChartConfig;
  lineChartConfig?: LineChartConfig;
  barChartConfig?: BarChartConfig;
  pieChartConfig?: PieChartConfig;

  // Loading states
  loadingRiskDistribution = false;
  loadingPerformanceDistribution = false;
  loadingRiskTrends = false;
  loadingLineChart = false;
  loadingBarChart = false;
  loadingPieChart = false;

  constructor(
    private mockApiService: MockChartApiService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadAllCharts();
  }

  /**
   * Load all chart data from mock API
   */
  loadAllCharts(): void {    
    // Risk Distribution (Boxplot)
    this.loadingRiskDistribution = true;
    this.mockApiService.getRiskDistribution().subscribe({
      next: (config) => {
        this.riskDistributionConfig = config;
        this.loadingRiskDistribution = false;
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error("Error loading risk distribution:", error);
        this.loadingRiskDistribution = false;
        this.cdr.detectChanges();
      },
    });

    // Performance Distribution (Mixed)
    this.loadingPerformanceDistribution = true;
    this.mockApiService.getPerformanceDistribution().subscribe({
      next: (config) => {
        this.performanceDistributionConfig = config;
        this.loadingPerformanceDistribution = false;
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Error loading performance distribution:', error);
        this.loadingPerformanceDistribution = false;
        this.cdr.detectChanges();
      },
    });

    // Risk Trends (Time Series)
    this.loadingRiskTrends = true;
    this.mockApiService.getRiskTrends().subscribe({
      next: (config) => {
        this.riskTrendsConfig = config;
        this.loadingRiskTrends = false;
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Error loading risk trends:', error);
        this.loadingRiskTrends = false;
        this.cdr.detectChanges();
      },
    });

    // Line Chart
    this.loadingLineChart = true;
    this.mockApiService.getLineChartData().subscribe({
      next: (config) => {
        this.lineChartConfig = config;
        this.loadingLineChart = false;
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Error loading line chart:', error);
        this.loadingLineChart = false;
        this.cdr.detectChanges();
      },
    });

    // Bar Chart
    this.loadingBarChart = true;
    this.mockApiService.getBarChartData().subscribe({
      next: (config) => {
        this.barChartConfig = config;
        this.loadingBarChart = false;
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Error loading bar chart:', error);
        this.loadingBarChart = false;
        this.cdr.detectChanges();
      },
    });

    // Pie Chart
    this.loadingPieChart = true;
    this.mockApiService.getPieChartData().subscribe({
      next: (config) => {
        this.pieChartConfig = config;
        this.loadingPieChart = false;
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Error loading pie chart:', error);
        this.loadingPieChart = false;
        this.cdr.detectChanges();
      },
    });
  }


  /**
   * Reload all charts
   */
  reloadCharts(): void {
    this.loadAllCharts();
  }
}

